import React from 'react';

import { Table } from 'react-bootstrap';
import moment from 'moment';
import styled from 'styled-components';

import DollarOutput from '../utils/DollarOutput';
import Sorter from '../utils/Sorting/Sorter';
import { EDT } from '../../infrastructure/constants/common';
import { isMobileResolution } from '../../infrastructure/utils/common';
import { Order } from '../../types/Order';

import PartyOrdersListMobile from './PartyOrdersList/PartyOrdersListMobile';

const StyledCeil = styled.td`
  vertical-align: middle;
`;

type Props = {
  orders: Order[];
  activeSort: () => void;
  handleOnClick: (event: React.MouseEvent<HTMLElement>, url: string) => void;
  changeSort: (val: string) => void;
};

const OrdersList = ({
  orders,
  activeSort,
  handleOnClick,
  changeSort,
}: Props) => {
  const onRowClick = event => {
    event.preventDefault();
    handleOnClick(event, event.currentTarget.getAttribute('href'));
  };

  const onChangeSortClick = event => {
    event.stopPropagation();
    event.preventDefault();
    changeSort(event.currentTarget.getAttribute('name'));
  };

  const getEventDate = (order: Order) =>
    `${moment(order.startDateTime)
      .tz(order.partyTz || EDT)
      .format('YYYY-MM-DD hh:mm A ')}`;

  const getOrderPlacedDate = order =>
    moment(order.created).tz(EDT).format('YYYY-MM-DD hh:mm A');

  if (isMobileResolution()) {
    return (
      <PartyOrdersListMobile
        orders={orders}
        getEventDate={getEventDate}
        getOrderPlacedDate={getOrderPlacedDate}
        onOrderClick={onRowClick}
      />
    );
  }

  return (
    <div className='orderslist'>
      <Table hover>
        <thead>
          <tr>
            <th
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              name='name'
              className='sortColumn'
              onClick={onChangeSortClick}
            >
              Order Name <Sorter activeSort={activeSort} name='name' />
            </th>
            <th
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              name='startDateTime'
              className='sortColumn'
              onClick={onChangeSortClick}
            >
              Event Start{' '}
              <Sorter activeSort={activeSort} name='startDateTime' />
            </th>
            <th
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              name='activity.vendorName'
              className='sortColumn'
              onClick={onChangeSortClick}
            >
              Vendor Name
              <Sorter activeSort={activeSort} name='activity.vendorName' />
            </th>
            <th
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              name='customer.memberName'
              className='sortColumn'
              onClick={onChangeSortClick}
            >
              Customer Name
              <Sorter activeSort={activeSort} name='customer.memberName' />
            </th>
            <th
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              name='totalPrice'
              className='sortColumn'
              onClick={onChangeSortClick}
            >
              Total Price <Sorter activeSort={activeSort} name='totalPrice' />
            </th>
            <th
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              name='status'
              className='sortColumn'
              onClick={onChangeSortClick}
            >
              Status <Sorter activeSort={activeSort} name='status' />
            </th>
            <th
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              name='created'
              className='sortColumn'
              onClick={onChangeSortClick}
            >
              Order Placed Date{' '}
              <Sorter activeSort={activeSort} name='created' />
            </th>
          </tr>
        </thead>
        <tbody>
          {orders.map(order => (
            <tr
              key={order.id}
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              href={`/orders/${order.id}`}
              className='listrow'
              onClick={onRowClick}
            >
              <StyledCeil>{order.name}</StyledCeil>
              <StyledCeil>{getEventDate(order)}</StyledCeil>
              <StyledCeil>{order.activity?.vendorName || ''}</StyledCeil>
              <StyledCeil>{order.customer?.memberName || ''}</StyledCeil>
              <StyledCeil>
                <DollarOutput value={order.totalPrice} />
              </StyledCeil>
              <StyledCeil>{order.status}</StyledCeil>
              <StyledCeil>{getOrderPlacedDate(order)}</StyledCeil>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default React.memo(OrdersList);
